export const QueryGroupMemberInFolderRepository = Symbol.for('QueryGroupMemberInFolderRepository');
